// extracted by mini-css-extract-plugin
export default {"contentWithSVGIcon":"n9Vy","children":"G_4G","icon":"bc5n"};